// extracted by mini-css-extract-plugin
export default {"icon":"Icon-module--icon--NiaxQ"};